// extracted by mini-css-extract-plugin
export default {"box":"kyz_Ix","video":"yhz9pE","youtube":"YIHuSd","play":"Cw557E"};